import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { useTheme } from 'styled-components'
import { useIsUserVerified } from 'state/user/hooks'
import { Text, Modal, Flex } from '@mprolab/uikit'
import { StatusBar } from '../components'

interface AwaitingVerificationModalProps {
  onDismiss?: () => void
  onVerificationDeclined?: () => void
}

const StyledModalWrapper = styled(Flex)`
  flex-direction: column;
  ${({ theme }) => theme.mediaQueries.sm} {
    width: 100%;
  }
  ${({ theme }) => theme.mediaQueries.md} {
    width: 493px;
  }
`

const AwaitingVerificationModal: React.FC<AwaitingVerificationModalProps> = (props) => {
  const { t } = useTranslation()
  const { onDismiss = () => null, onVerificationDeclined = () => null } = props
  const theme = useTheme()
  const isUserVerified = useIsUserVerified()

  const closeModalHandler = () => {
    onVerificationDeclined()
    onDismiss()
  }

  return (
    <Modal onDismiss={closeModalHandler} title={t('web3Modal.title')}>
      <StyledModalWrapper>
        <Text color={theme.colors.gray6}>{t('web3Modal.description')}</Text>
      </StyledModalWrapper>
      <Flex mt="40px" width="100%" justifyContent="center">
        <StatusBar isUserVerified={isUserVerified} isLoading />
      </Flex>
    </Modal>
  )
}

export default AwaitingVerificationModal
